import { useGlobal } from "../../../core/Global"
import ChatDeleteConfirmModal from "./ChatDeleteConfirmModal"
import ChatQuickRepliesManage from "./ChatQuickRepliesManage"
import ChatRenameModal from "./ChatRenameModal"
import ChatSettingsModal from "./ChatSettingsModal"
import ChatUsersAccess from "./ChatUsersAccess"



export default function ChatGlobalModals() {

    const [globalState] = useGlobal()


    return (
        <>
            {globalState.deleteChat && <ChatDeleteConfirmModal chat={globalState.deleteChat} />}
            {globalState.chatAccessDrawer && <ChatUsersAccess chat={globalState.chatAccessDrawer} />}
            {globalState.chatSettingsModal && <ChatSettingsModal chat={globalState.chatSettingsModal} />}
            {globalState.chatRenameModal && <ChatRenameModal chat={globalState.chatRenameModal} />}

            {globalState.chatQuickRepliesModal && <ChatQuickRepliesManage />}

        </>
    )
}